// extracted by mini-css-extract-plugin
export default {"localeSwitcher":"LocaleSwitcher_localeSwitcher__Hh46P","imageLang":"LocaleSwitcher_imageLang__0twl7"};